import { render, staticRenderFns } from "./Diagnostics.vue?vue&type=template&id=b4b575d6&scoped=true"
import script from "./Diagnostics.vue?vue&type=script&lang=js"
export * from "./Diagnostics.vue?vue&type=script&lang=js"
import style0 from "./Diagnostics.vue?vue&type=style&index=0&id=b4b575d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b575d6",
  null
  
)

export default component.exports